import React from 'react';
import AuthModal from './AuthModal';

const ProviderSignupPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AuthModal 
        isOpen={true} 
        onClose={() => {}} 
        defaultTab="signup"
        fixedUserType="provider"
      />
    </div>
  );
};

export default ProviderSignupPage;
